/**
 * Shared helpers for the mock-first services (CT-3904 backend TODO per
 * function). Both `integrationsService.js` and `marketplaceService.js` wrap
 * responses in the same platform envelope and filter mock rows the same way —
 * one definition so they can't silently drift apart.
 */

export const envelope = (body, meta = {}) => ({ status_code: 200, body, meta });

/** 404-style envelope so callers can tell “not found” from a failed request. */
export const notFoundEnvelope = () => ({
  status_code: 404,
  body: null,
  meta: {},
  msg_code: [{ code: 'NOT_FOUND', description: 'Not found' }],
});

export const matchesFilters = (item, filters = {}) =>
  Object.entries(filters).every(([key, value]) => {
    if (value == null || value === '' || (Array.isArray(value) && value.length === 0)) return true;
    const field = item[key];
    // Handle every combination of scalar/array on both sides so a filter can be
    // a single value or a multi-select, against a scalar field (e.g. `category`)
    // or an array field (e.g. `capability_types`, `used_in_studio`):
    if (Array.isArray(value)) {
      // multi-select → array field: any overlap; scalar field: membership.
      return Array.isArray(field) ? value.some((v) => field.includes(v)) : value.includes(field);
    }
    // single value → array field: membership; scalar field: equality.
    return Array.isArray(field) ? field.includes(value) : field === value;
  });
